import { styled, Typography } from "@mui/material";
import { Modal } from "@mekidoc/ui";

const SecondFactorExplanationModalContent = styled(Typography)({
  textAlign: "left",
  marginBottom: "16px",
});

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// Speaks of the providers in general: the doctor may sign with any of them, so
// none is named.
export const SecondFactorExplanationModal: React.FC<Props> = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Segundo factor de autenticación"
    content={
      <>
        <SecondFactorExplanationModalContent>
          Para proteger la validez legal de la firma electrónica avanzada, es necesario
          contar con un segundo factor de autenticación.
        </SecondFactorExplanationModalContent>
        <SecondFactorExplanationModalContent>
          Esta medida es exigida por nuestros proveedores de firma electrónica avanzada.
        </SecondFactorExplanationModalContent>
      </>
    }
  />
);
